import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChartDataSets, ChartOptions } from 'chart.js';
import html2canvas from 'html2canvas';
import { Label } from 'ng2-charts';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Helpers } from 'src/app/helpers/helpers';

@Component({
  selector: 'app-custom-test-history',
  templateUrl: './custom-test-history.component.html',
  styleUrls: ['./custom-test-history.component.css']
})
export class CustomTestHistoryComponent implements OnInit {

  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:9, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: false
    },
    
  }

  public barChartLabels: Label[] = [];
  public barChartData: ChartDataSets[] = [
    { data: [], label: 'Puntaje', backgroundColor:'#009efb', hoverBackgroundColor:'#009efb', borderColor: 'black', pointBackgroundColor: 'black', pointBorderColor: 'black', pointHoverBackgroundColor: 'black', pointHoverBorderColor: 'black', borderWidth: 1 },
  ];
  public user: any;
  public testName: ''
    

  constructor(
    private testService: TestService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    let testId = this.route.snapshot.queryParamMap.get('testId');
    let userEmail = this.route.snapshot.queryParamMap.get('userEmail');
    // console.log(testId, userEmail)
    this.userService.getUserByEmail(userEmail).subscribe( resp => {
      this.user = resp
    })
    this.testService.getEvaluatedTests(userEmail).subscribe( resp => {
      // console.log(resp)
      let filtered = resp.filter( test => test.completeForm == testId)
      if (filtered.length > 0){
        this.testName = filtered[0].type
      }
      // console.log(filtered)
      filtered.forEach( test => {
        this.barChartLabels.push(this.datePipe.transform(test.createDate, 'dd/MM/yyyy'))
        this.barChartData[0].data.push(test.formScore)
      })
    })
  }

  back(){
    window.history.back();
  }

  async share(){
    let url = `${location.origin}/dashboard/custom-test-history?share=true&testId=${this.route.snapshot.queryParamMap.get('testId')}&userEmail=${this.user.email}`;
    await navigator.clipboard.writeText(url);
    Swal.fire({
      icon:'success',
      text:'Enlace copiado al portapapeles',
      showConfirmButton: false,
      timer: 1500
    })
  }




    public async generatePdf(){

      let logoUrl =  'https://i.imgur.com/EFIjUdn.png';
  
      scrollTo(1,0);
      let answers = [];
  
      let i = 0;

      let doc = {
        info:{
          title:`Reporte histórico de ${this.user.name} para ${this.testName}.pdf`
        },
        footer: function (currentPage, pageCount) {
          return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
        },
        pageMargins: [ 40, 70, 40, 60 ],
        header:{
          columns:[
            {},
            {image:await Helpers.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
          ],
        },
        pageSize:'A4',
        content:[
          {
            text: `Reporte histórico de ${this.user.name} para ${this.testName}.pdf`,
            bold: true,
            fontSize:16,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          },
          {
            image:(await html2canvas(document.querySelector("#pfChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          },

        ]
      }
      pdfMake.createPdf(doc).download(`Reporte histórico de ${this.user.name} para ${this.testName}.pdf`);
  
    }

}
